import { render, staticRenderFns } from "./IconWifiOutline.vue?vue&type=template&id=ff25ea44"
import script from "./IconWifiOutline.vue?vue&type=script&lang=js"
export * from "./IconWifiOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports